/*
    Made by : Samuel
    date :
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import { ReactNode } from "react";
import styles from "./NotFound.module.css";

// ----------------------------------------------------------------------------- //
// PROPS //

interface NotFoundWrapperProps {
    children: ReactNode;
}

// ----------------------------------------------------------------------------- //
// COMPONENT //

function NotFoundWrapper({ children }: NotFoundWrapperProps) {
    return <div className={styles.wrapper}>{children}</div>;
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default NotFoundWrapper;

// ----------------------------------------------------------------------------- //
